import { memo } from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import OpenDoorAwardsText from "@/icons/__generated__/AwardsWinnerBadge/OpenDoorAwardsText";

/**
 * This is the content for the Awards Winner Badge.
 */

import type { AwardsWinnerContentProps } from "~/components/gallery/photo-gallery.types";
const AwardsWinnerContent = ({
  category,
  closeButton,
  linkLocale,
  listingAwards,
  listingCity,
  listingUseType,
  year,
}: AwardsWinnerContentProps) => {
  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-bg-base-black tw-pt-24 md:tw-pt-12 tw-px-24 md:tw-px-16 tw-pb-28 md:tw-pb-32 tw-rounded-t-8">
        {closeButton}
        <OpenDoorAwardsText className="tw-mb-16" />
        <Text typeface="body-1-m" className="tw-text-base-white tw-mb-4">
          {listingAwards.type === "metro" && listingUseType && (
            <FormattedMessage
              id="listing.awards_tooltip.best_in_use_type_spaces"
              defaultMessage="Best in {useType} Spaces"
              values={{
                useType: listingUseType,
              }}
            />
          )}
          {listingAwards.type === "category" &&
            (category ? (
              <FormattedMessage
                id="listing.awards_tooltip.best_in_category_spaces"
                defaultMessage="Best in {category}"
                values={{
                  category,
                }}
              />
            ) : (
              (listingAwards.category as string)
            ))}
        </Text>
        <Text
          typeface="body-1-m"
          className="tw-flex tw-gap-8 tw-items-center tw-text-gray-500"
        >
          <FormattedMessage
            id="listing.awards_tooltip.winner"
            defaultMessage="{year} Winner"
            values={{
              year,
            }}
          />
          {listingAwards.type === "metro" && (
            <>
              <span className="tw-size-8 tw-rounded-circular tw-bg-gray-500" />
              {listingCity}
            </>
          )}
        </Text>
      </div>
      <div className="tw-flex tw-flex-col tw-text-gray-900 tw-bg-base-white tw-p-24 md:tw-p-16 tw-rounded-b-8">
        <Text typeface="body-1-m" className="tw-mb-4">
          <FormattedMessage
            id="listing.awards_tooltip.what_are_awards"
            defaultMessage="What are the Open Door Awards?"
          />
        </Text>
        <Text typeface="body-1-long" className="tw-mb-24 md:tw-mb-16">
          <FormattedMessage
            id="listing.awards_tooltip.what_are_awards_text"
            defaultMessage="Peerspace's Open Door Awards celebrate the most extraordinary spaces in the Event, Meeting, and Production categories in cities around the world."
          />
        </Text>
        <Button
          appearance="purple"
          className="tw-body-1-m-long tw-self-start tw-underline"
          variant="text-only"
          href={`https://madein.peerspace.com${linkLocale}/awards`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <FormattedMessage
            id="listing.awards_tooltip.learn_more"
            defaultMessage="Learn more"
          />
        </Button>
      </div>
    </>
  );
};

export default memo(AwardsWinnerContent);
